import React, { useCallback, useEffect, useState } from 'react';
import { RotateCcw, Trash2 } from 'lucide-react';

// Admin → Koš: customers moved to the trash (soft delete) with a restore action.
const CustomerTrash = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');

  const load = useCallback(async () => {
    setError('');
    try {
      const res = await fetch('/api/customers/trash', { credentials: 'include' });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(res.status === 403 ? 'Koš může spravovat jen administrátor.' : json.error || `Chyba ${res.status}`);
      setItems(json.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const restore = async (c) => {
    setError(''); setNotice('');
    try {
      const res = await fetch(`/api/customers/${c.id}/restore`, { method: 'POST', credentials: 'include' });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.error || `Chyba ${res.status}`);
      setNotice(`Zákazník „${c.school_name || c.company_name}“ byl obnoven.`);
      await load();
    } catch (err) {
      setError(`Obnovení se nezdařilo: ${err.message}`);
    }
  };

  return (
    <div>
      <h2 style={{ fontSize: '18px', fontWeight: 600, color: '#333', margin: '0 0 8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Trash2 size={20} color="#E53935" /> Koš zákazníků
      </h2>
      <p style={{ fontSize: '13px', color: '#666', margin: '0 0 16px' }}>
        Smazaní zákazníci zůstávají i se svými trenažéry a dokumenty. Po obnovení se vrátí do seznamů, mapy a přehledů.
      </p>
      {notice && <p role="status" style={{ padding: '10px 14px', borderRadius: '8px', backgroundColor: '#E8F5E9', color: '#2E7D32', fontSize: '14px', margin: '0 0 12px' }}>{notice}</p>}
      {error && <p role="alert" style={{ padding: '10px 14px', borderRadius: '8px', backgroundColor: '#FFEBEE', color: '#D32F2F', fontSize: '14px', margin: '0 0 12px' }}>{error}</p>}
      {loading ? <p style={{ color: '#666' }}>Načítám…</p> : items.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#999', padding: '32px' }}>Koš je prázdný</p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#666', borderBottom: '1px solid #E0E0E0' }}>
                <th style={{ padding: '8px' }}>Zákazník</th><th style={{ padding: '8px' }}>IČO</th><th style={{ padding: '8px' }}>Město</th>
                <th style={{ padding: '8px' }}>Trenažérů</th><th style={{ padding: '8px' }}>Smazáno</th><th style={{ padding: '8px' }} />
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} style={{ borderBottom: '1px solid #F0F0F0' }}>
                  <td style={{ padding: '8px', fontWeight: 600, color: '#333' }}>{c.school_name || c.company_name}</td>
                  <td style={{ padding: '8px' }}>{c.ico || '–'}</td>
                  <td style={{ padding: '8px' }}>{c.city || '–'}</td>
                  <td style={{ padding: '8px' }}>{c.machine_count}</td>
                  <td style={{ padding: '8px', color: '#666' }}>{new Date(c.deleted_at).toLocaleString('cs-CZ')}{c.deleted_by_username ? ` · ${c.deleted_by_username}` : ''}</td>
                  <td style={{ padding: '8px', textAlign: 'right' }}>
                    <button type="button" onClick={() => restore(c)} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '8px 12px', borderRadius: '8px', border: 'none', backgroundColor: '#E53935', color: '#FFF', cursor: 'pointer', fontSize: '13px', fontWeight: 500 }}>
                      <RotateCcw size={14} /> Obnovit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CustomerTrash;
